import React, { useEffect, useMemo } from "react";
import EmojiCard from "./EmojiCard";
import VerticalBar from "./VerticalBar";
import { Select } from "antd";
import { useState } from "react";
import { Tabs } from "antd";
import images from "../../../themes/appImage";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  averageMoodLoad,
  moodsLoggedLoad,
} from "../../../redux/slices/dash.slice";

const { Option } = Select;

const NewChart = ({ tab, orgId, department }) => {
  let data = moment().month();
  const [month, setMonth] = useState(data);
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    Date.UTC(currentDate.getFullYear(), month, 1)
  );
  const lastDayOfMonth = new Date(
    Date.UTC(currentDate.getFullYear(), month + 1, 0, 23, 59, 59)
  );

  const averageData = {
    logType: "mood",
    organisation: orgId,
    startDate: firstDayOfMonth.toISOString(),
    endDate: lastDayOfMonth.toISOString(),
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (tab == 1) {
      const data = {
        month: month,
        organisation: orgId,
        department,
      };

      dispatch(moodsLoggedLoad(data));
      dispatch(averageMoodLoad({ ...averageData, department }));
    }
  }, [month, tab, dispatch, department]);

  const mydata = useSelector((state) => state.dashboardReducer) || {};
  const moodsData = mydata?.moodsData;
  const averageMoodData = mydata?.averageData;
  const currentMonthMean = averageMoodData?.currentMonthMean;
  const percentageChange = averageMoodData?.percentageChange;

  const findNearestKey = (moodData, currentMonthMean) => {
    let nearestKey = null;
    let minDifference = Infinity;

    // Iterate through the keys of moodData
    for (const key in moodData) {
      if (moodData.hasOwnProperty(key)) {
        // Calculate the absolute difference between the currentMonthMean and the value of the key
        const difference = Math.abs(currentMonthMean - moodData[key]);

        // Update nearestKey and minDifference if this key's value is closer to the currentMonthMean
        if (difference < minDifference) {
          nearestKey = key;
          minDifference = difference;
        }
      }
    }

    return nearestKey;
  };

  // Find the nearest key
  const nearestKey = findNearestKey(moodsData, currentMonthMean);

  let totalSum = 0;
  for (const key in mydata.moodsData) {
    if (key != "_id") {
      totalSum += mydata?.moodsData[key];
    }
  }

  const moodData = useMemo(() => {
    return [
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.bestPossible / totalSum) * 100 : 0
        }`,
        imageSource: images.bestPossibleMood,
        altText: "bestPossible",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.great / totalSum) * 100 : 0
        }`,
        imageSource: images.greatMood,
        altText: "great",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.veryGood / totalSum) * 100 : 0
        }`,
        imageSource: images.veryGoodMood,
        altText: "veryGood",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.good / totalSum) * 100 : 0
        }`,
        imageSource: images.goodMood,
        altText: "good",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.prettyGood / totalSum) * 100 : 0
        }`,
        imageSource: images.PrettyGood,
        altText: "prettyGood",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.okay / totalSum) * 100 : 0
        }`,
        imageSource: images.okMood,
        altText: "okay",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.beenBetter / totalSum) * 100 : 0
        }`,
        imageSource: images.beenBetter,
        altText: "beenBetter",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.bad / totalSum) * 100 : 0
        }`,
        imageSource: images.badMood,
        altText: "bad",
      },
      {
        percentage: `${
          totalSum !== 0 ? (mydata?.moodsData.veryBad / totalSum) * 100 : 0
        }`,
        imageSource: images.veryBadMood,
        altText: "veryBad",
      },
      {
        percentage: `${
          totalSum !== 0
            ? (mydata?.moodsData.worstPossible / totalSum) * 100
            : 0
        }`,
        imageSource: images.worstPossibleMood,
        altText: "worstPossible",
      },
    ];
  }, [mydata?.moodsData]);
  const handleMonthChange = (value) => {
    console.log("the value of month is", value);
    setMonth(value);
  };

  const nearestMood = moodData.find((mood) => mood.altText === nearestKey);
  const nearestImageSource = nearestMood ? nearestMood.imageSource : null;

  return (
    <div>
      <div className="flex justify-between  lg:flex-col lg:items-center  gap-3 w-[100%]">
        <div className="w-[70%] pb-2">
          <div className="flex  items-center justify-between months-selector  ">
            <div></div>
            <div className="w-[100px]">
              <Select
                defaultValue={month.toString()}
                onChange={handleMonthChange}
              >
                <Option value="0">January</Option>
                <Option value="1">February</Option>
                <Option value="2">March</Option>
                <Option value="3">April</Option>
                <Option value="4">May</Option>
                <Option value="5">June</Option>
                <Option value="6">July</Option>
                <Option value="7">August</Option>
                <Option value="8">September</Option>
                <Option value="9">October</Option>
                <Option value="10">November</Option>
                <Option value="11">December</Option>
              </Select>
            </div>
          </div>

          <div className="flex gap-5 h-[300px] items-end px-[15px] justify-evenly">
            {moodData.map((mood, index) => (
              <VerticalBar
                key={index}
                barPercentage={
                  Number(mood.percentage) > 100
                    ? "100%"
                    : Number(mood.percentage) < 18
                    ? "18%"
                    : mood.percentage + "%"
                }
                textPercentage={Math.floor(Number(mood.percentage)) + "%"}
                imageSource={mood.imageSource}
                altText={mood.altText}
              />
            ))}
          </div>
        </div>
        <div className="w-[30%] flex mb-2">
          <EmojiCard
            moodImage={nearestImageSource}
            moodDescription={nearestKey}
            percentageChange={percentageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default NewChart;
